const carouselItems = [
  {
    img: 'https://readdy.ai/api/search-image?query=A%20cinematic%20wide%20banner%20with%20a%20futuristic%20city%20and%20spaceships%20in%20dramatic%20golden%20sunset%20lighting%2C%20epic%20sci-fi%20atmosphere%2C%20wide%20cinematic%20composition%2C%20warm%20amber%20and%20deep%20shadow%20contrast%2C%20no%20text&width=1100&height=500&seq=carousel-focus-01&orientation=landscape',
    title: '科幻电影周：探索未知宇宙',
    desc: '精选12部高分科幻巨制，从星际穿越到人工智能，带你领略科幻电影的无尽想象。',
    tag: '专题策划',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=A%20cinematic%20wide%20banner%20with%20ancient%20Chinese%20warriors%20marching%20through%20a%20vast%20battlefield%20at%20dawn%2C%20epic%20historical%20atmosphere%2C%20warm%20golden%20morning%20light%2C%20dramatic%20composition%2C%20no%20text&width=1100&height=500&seq=carousel-focus-02&orientation=landscape',
    title: '国产神话宇宙：封神系列全回顾',
    desc: '从封神第一部到最新续作，深度解析国产神话电影宇宙的宏大叙事与视觉突破。',
    tag: '深度解析',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=A%20cinematic%20wide%20banner%20with%20a%20colorful%20animated%20dragon%20and%20mythical%20creatures%20in%20a%20magical%20Chinese%20landscape%2C%20vibrant%20warm%20colors%2C%20dynamic%20action%20composition%2C%20no%20text&width=1100&height=500&seq=carousel-focus-03&orientation=landscape',
    title: '国漫崛起进行时',
    desc: '从哪吒到长安三万里，国产动画电影的黄金时代已经到来，不容错过的精品全收录。',
    tag: '行业观察',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=A%20cinematic%20wide%20banner%20with%20a%20mysterious%20detective%20figure%20in%20a%20rainy%20ancient%20Chinese%20street%20at%20night%2C%20noir%20atmosphere%20with%20lantern%20glow%2C%20suspenseful%20cinematic%20lighting%2C%20no%20text&width=1100&height=500&seq=carousel-focus-04&orientation=landscape',
    title: '暑期追剧指南：悬疑探案篇',
    desc: '大奉打更人领衔暑期档悬疑剧集，层层反转烧脑不断，陪你度过炎炎夏日。',
    tag: '追剧指南',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=A%20cinematic%20wide%20banner%20with%20warm%20nostalgic%20old%20film%20reels%20and%20vintage%20movie%20posters%20on%20a%20theater%20wall%2C%20soft%20golden%20lighting%2C%20classic%20cinema%20atmosphere%2C%20no%20text&width=1100&height=500&seq=carousel-focus-05&orientation=landscape',
    title: '经典港片修复计划',
    desc: '高清修复版经典港片陆续上线，王家卫、周星驰、吴宇森名作高清重温。',
    tag: '经典重现',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=A%20cinematic%20wide%20banner%20with%20abstract%20golden%20Oscar%20statue%20silhouette%20and%20dramatic%20spotlight%20effects%20on%20a%20dark%20stage%2C%20elegant%20awards%20ceremony%20atmosphere%2C%20warm%20premium%20lighting%2C%20no%20text&width=1100&height=500&seq=carousel-focus-06&orientation=landscape',
    title: '奥斯卡获奖影片专区',
    desc: '历年奥斯卡最佳影片、最佳外语片高清合集，一站式品味电影艺术的巅峰之作。',
    tag: '影史经典',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            特别企划
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            焦点专题
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-lg mx-auto">
            深度策划的影视专题内容，带你发现更多好片
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.map((item) => (
            <article
              key={item.title}
              className="group cursor-pointer rounded-xl overflow-hidden bg-background-100"
            >
              <div className="relative aspect-[2.2/1] overflow-hidden bg-background-200">
                <img
                  src={item.img}
                  alt={`6080新视觉影院 - ${item.title}`}
                  title={`${item.title} - 6080新视觉影院高清电影`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="inline-block px-2.5 py-1 rounded-md bg-accent-500/90 text-background-50 text-xs font-medium whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-sm font-semibold text-foreground-800 group-hover:text-primary-700 transition-colors mb-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}